import { CREATE_NEW_MERCHANT } from '../constants';
import { FeeService } from '../services/FeeService';
import { merchantServices } from '../services/merchantServices';
import { OffenseService } from '../services/OffenseService';
import { officerServices } from '../services/officerServices';
import { SUCCESSFUL_REQUEST_CODE } from './apiUtils';

export const AsyncPaginateGetOptions = () => {
	const { getArrestingORI } = OffenseService();
	const { getOfficerData } = officerServices();
	const { getFees } = FeeService();
	const { getMerchants } = merchantServices();

	const getAgenciesData = async (agencyName, _, { pageNumber }) => {
		let options = [];
		let hasMoreResults = true;
		try {
			const response = await getArrestingORI(pageNumber, 10, agencyName);
			if (SUCCESSFUL_REQUEST_CODE.includes(response.status)) {
				const { data } = response;
				options = data?.content?.map((items) => ({
					value: items.arrestingAgencyOriId,
					label: `${items.agencyOri} ${items.agencyName}`
				}));
				hasMoreResults = !data.last;
			} else {
				hasMoreResults = false;
			}
			return {
				options: options,
				hasMore: hasMoreResults,
				additional: {
					pageNumber: pageNumber + 1
				}
			};
		} catch (error) {
			console.error('Unable to get agencies data', error);
		}
	};

	const getOfficersData = async (officerName, _, { pageNumber }, type) => {
		let options = [];
		let hasMoreResults = true;
		try {
			const response = await getOfficerData(type, pageNumber, 25, officerName);
			if (SUCCESSFUL_REQUEST_CODE.includes(response.status)) {
				const { data } = response;
				options = data.content.map((item) => ({
					label: item.officerName,
					value: item.officerId
				}));
				hasMoreResults = !data.last;
			} else {
				hasMoreResults = false;
			}
			return {
				options: options,
				hasMore: hasMoreResults,
				additional: {
					pageNumber: pageNumber + 1
				}
			};
		} catch (error) {
			console.error('Unable to get officers data', error);
		}
	};

	const getFeesCodeData = async (_, __, { pageNumber }) => {
		let options = [];
		let hasMoreResults = true;
		try {
			const response = await getFees(pageNumber, 25);
			if (SUCCESSFUL_REQUEST_CODE.includes(response.status)) {
				const { data } = response;
				options = data.feeCodes.map((item) => ({
					label: item.description,
					value: item.feeCodeId,
					code: item.feeCode
				}));
				hasMoreResults = !data.last;
			} else {
				hasMoreResults = false;
			}
			return {
				options: options,
				hasMore: hasMoreResults,
				additional: {
					pageNumber: pageNumber + 1
				}
			};
		} catch (error) {
			console.error('Unable to get Fees Code Data', error);
		}
	};

	const getMerchantData = async (merchantName, __, { pageNumber }, showCreateNew = false) => {
		let options = [];
		let hasMoreResults = true;
		try {
			const response = await getMerchants(pageNumber, 25, merchantName);
			if (SUCCESSFUL_REQUEST_CODE.includes(response.status)) {
				const { data } = response;
				options = data.content.map((item) => ({
					label: item.businessName,
					value: item.merchantId
				}));
				if (pageNumber === 0 && showCreateNew) {
					options = [CREATE_NEW_MERCHANT, ...options];
				}
				hasMoreResults = !data.last;
			} else {
				hasMoreResults = false;
			}
			return {
				options: options,
				hasMore: hasMoreResults,
				additional: {
					pageNumber: pageNumber + 1
				}
			};
		} catch (error) {
			console.error('Unable to get merchant Data', error);
		}
	};

	return {
		getAgenciesData,
		getOfficersData,
		getFeesCodeData,
		getMerchantData
	};
};
